import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICardDetail_BodyList } from '@models/card.model';

@Component({
  selector: 'app-card-detail-body-col',
  templateUrl: './card-detail-body-col.component.html',
  styleUrls: ['./card-detail-body-col.component.scss'],
})
export class CardDetailBodyColComponent implements OnInit {
  @Input() title: string;
  @Input() bodyList: ICardDetail_BodyList[];
  @Input() loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  @Input() emptyStateDetailBody?: string = '';

  constructor() {}

  ngOnInit(): void {}
}
